<template>
  <div>
    <div class="shopCard" v-for="item in data" :key="item.contentId">
      <div class="shopCard-container">
        <div>
          <!-- 单品 start -->
          <div class="shop-single" v-if="item.logo">
            <div class="shopCard-left">
              <el-image
                style="width: 100px; height: 100px"
                :src="item.logo"
                fit="fit"
              ></el-image>

              <div class="shopCard-info">
                <div>{{ item.templateName }}</div>
                <span
                  v-for="(specsItem, specsIndex) in item.specs"
                  :key="specsIndex"
                  >{{ specsItem.specValue + specsItem.specUnit }}</span
                >
                <div>
                  {{ item.price }} <span>{{ item.originPrice }}</span>
                </div>
              </div>
            </div>
            <!-- <div class="shopCard-right">x{{ item.num }}</div> -->
          </div>
          <!-- 单品 end -->

          <!-- 工时 start -->
          <div v-if="item.laborCost" class="shop-laborCost">
            <div class="shopCard-left">
              <el-image
                v-if="item.laborCost.logo"
                style="width: 100px; height: 100px"
                :src="item.laborCost.logo"
                fit="fit"
              ></el-image>
              <div class="shopCard-info">
                <div>{{ item.laborCost.skuName }}</div>
                <span>{{
                  item.laborCost.specValue + item.laborCost.specUnit
                }}</span>
                <div>
                  {{ item.laborCost.laborCost }} <span>{{ item.laborCost.originPrice }}</span>
                </div>
              </div>
            </div>
            <!-- <div class="shopCard-right">x{{ item.laborCost.num }}</div> -->
          </div>
          <!-- 工时 end -->
        </div>

        <!-- 数量 -->
        <div class="shopCard-right" v-if="packageType===1">x{{ item.num }}</div>
      </div>
      <el-divider></el-divider>
    </div>
  </div>
</template>

<script>
export default {
  name: 'shopCard',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    packageType: {
      type: Number,
      default: 1,
    },
  },

}
</script>


<style lang="scss" scoped>
.shopCard-container {
  display: flex;
  justify-content: space-between;
}
.shop-single,
.shop-laborCost {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.shopCard-left {
  display: flex;
  .shopCard-info {
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    & > div:nth-child(1) {
      font-weight: 500;
      font-size: 14px;
    }
    & > div:nth-child(3) {
      font-size: 14px;
    }
    & > div:nth-child(3) span {
      text-decoration: line-through;
      color: #999;
    }
  }
}
.shopCard-right {
  font-size: 18px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 20px;
}
</style>
